module.exports = __webpack_public_path__ + "static/media/bootstrap-plain.c4ce29f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bootstrap-plain.svg
// module id = 93
// module chunks = 0